export default __webpack_public_path__ + "static/media/closeButton2.38f28460.svg";